import React, { useState } from 'react';
import {
  Modal,
  Space,
  InputTextArea,
  Button,
  Loader,
  openNotification,
  CodeView,
} from 'tt-ui-lib/core';
import { adminSignMessageRequest } from '../../../../api/blockchain/endpoints/blockcahin-da-api';

const SignMessageModal = ({ open, setOpen }) => {
  const [message, setMessage] = useState('');
  const [signature, setSignature] = useState('');
  const [messageHash, setMessageHash] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCancel = () => {
    setOpen(false);
    setMessage('');
    setSignature('');
  };

  const handleSign = () => {
    if (!message) {
      openNotification({
        type: 'info',
        message: 'Please enter a message to sign',
      });
      return;
    }

    setLoading(true);

    adminSignMessageRequest({ message })
      .then((response) => {
        setMessageHash(response?.data?.result?.messageHash || '-');
        setSignature(response?.data?.result?.signature || '-');
      })
      .catch((error) => {
        openNotification({
          type: 'error',
          message: 'Error while signing message',
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal open={open} onCancel={handleCancel} title="Sign message" closeOnlyByControls>
      <Space direction="vertical" style={{ width: '100%' }}>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '200px',
              width: '100%',
            }}
          >
            <Loader />
          </div>
        ) : signature ? (
          <Space direction="vertical" style={{ width: '100%' }}>
            <CodeView
              code={{
                messageHash,
                signature,
              }}
              style={{ width: '100%', maxWidth: '100%', breakWord: 'break-all' }}
            />

            <Button
              type="default"
              onClick={() => {
                setMessage('');
                setSignature('');
                setMessageHash('');
              }}
              style={{ marginTop: '10px' }}
            >
              Back
            </Button>
          </Space>
        ) : (
          <>
            <div style={{ width: '100%', marginTop: '5px', marginBottom: '15px' }}>
              <InputTextArea
                label="Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            <Space
              direction="horizontal"
              style={{ width: '100%', justifyContent: 'space-between' }}
            >
              <Button type="default" onClick={handleCancel}>
                Cancel
              </Button>
              <Button type="primary" onClick={handleSign} disabled={!message}>
                Sign
              </Button>
            </Space>
          </>
        )}
      </Space>
    </Modal>
  );
};

export default SignMessageModal;
